function positionProductsSliderArrows($productsBlock, $heading) {
  const $target = window.matchMedia("(max-width: 767px)").matches || !$heading.length ? $productsBlock : $heading;
  const $arrows = $heading.find(".slick-arrow").add($productsBlock.find(".slick-arrow"));

  $target.append($arrows);
}

function watchProductsSliderArrows($productsBlock, $heading) {
  positionProductsSliderArrows($productsBlock, $heading);
  $(window).on("resize.productsSliderArrows", function () {
    positionProductsSliderArrows($productsBlock, $heading);
  });
}

$("body.in-index .products-block").each(function () {
  const $productsBlock = $(this);
  const $heading = $productsBlock.prevAll(".homepage-group-title.h4").first();

  $productsBlock.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    autoplay: false,
    autoplaySpeed: 5000,
    dots: false,
    arrows: true,
    appendArrows: $heading.length ? $heading : $productsBlock,
    infinite: false,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 3, slidesToScroll: 1 },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          appendArrows: $productsBlock,
          dots: true,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 2,
          dots: true,
        },
      },
    ],
  });
  watchProductsSliderArrows($productsBlock, $heading);
});
function initDetailProductsSliders() {
  $("body.type-detail .products-block, body.type-detail .products-related, body.type-detail .products-additional, body.type-detail .p-switchable.products")
    .not("#productsAlternative .products-block, #productsAlternative .products")
    .not(".slick-initialized")
    .each(function () {
      const $productsBlock = $(this);
      // vnořené kombinace tříd (products products-block products-related ...) jsou jeden element, vnitřní nechat být
      if ($productsBlock.parents(".slick-initialized").length || $productsBlock.find(".slick-initialized").length) {
        return;
      }
      const $heading = $productsBlock.prevAll(".products-related-header").first();

      $productsBlock.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,
        autoplay: false,
        autoplaySpeed: 5000,
        dots: false,
        arrows: true,
        appendArrows: $heading.length ? $heading : $productsBlock,
        infinite: false,
        adaptiveHeight: false,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
              appendArrows: $productsBlock,
              dots: true,
            },
          },
          {
            breakpoint: 550,
            settings: {
              slidesToShow: 2,
              dots: true,
            },
          },
        ],
      });
      watchProductsSliderArrows($productsBlock, $heading);
    });
}
initDetailProductsSliders();
document.addEventListener("ShoptetDOMContentLoaded", initDetailProductsSliders);
document.addEventListener("ShoptetDOMPageContentLoaded", initDetailProductsSliders);
